if (typeof $ !== "undefined" && $(".logo__slider_main .logo-list").length) {
  $(".logo__slider_main .logo-list").each(function (slider) {
    $(this).slick({
      centerMode: true,
      centerPadding: "10px",
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
}

/**
 * Defensive fix for mobile add-to-cart.
 *
 * Some product templates render the variant id input with `disabled` so the
 * theme's own variant picker can take over via JS. On mobile Safari with
 * custom elements + module imports + variant dropdown popovers, the input
 * sometimes stays disabled, which makes /cart/add.js return 422 (Bad Request)
 * with no visible error and the customer assumes "nothing happened".
 *
 * This script:
 *   - Removes `disabled` from every <input name="id"> inside a product form.
 *   - Re-applies that fix when variants change.
 *   - Ensures the form data sent on submit always includes a numeric variant id.
 */
(function () {
  function enableVariantIdInputs(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll(
      'form[is="product-form"], form[id^="product-form-"]'
    );
    forms.forEach(function (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.disabled) {
        idInput.disabled = false;
      }
    });
  }

  // Inside {% form 'product' %}, passing form: blank to the button snippet can
  // resolve to Shopify's form object and render form="" on the submit button.
  // That disconnects the button from the product form on iOS Safari (tap does nothing).
  function fixProductSubmitButtons(root) {
    var scope = root || document;
    scope
      .querySelectorAll(
        'form[is="product-form"] button[type="submit"], form[id^="product-form-"] button[type="submit"]'
      )
      .forEach(function (button) {
        var targetForm = button.getAttribute("form");
        if (targetForm === "" || targetForm === null) {
          button.removeAttribute("form");
        }
      });
  }

  function bind() {
    enableVariantIdInputs();
    fixProductSubmitButtons();

    // After any variant change, make sure the id input is still enabled
    // and has a value (the theme writes the new variant id to it).
    document.addEventListener("variant:change", function () {
      enableVariantIdInputs();
      fixProductSubmitButtons();
    });

    // Last-line-of-defense: if a product form is submitted but the id field
    // is missing or empty, append the value from the variant picker before
    // the request goes out.
    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (
          !form ||
          form.tagName !== "FORM" ||
          form.getAttribute("is") !== "product-form"
        ) {
          return;
        }

        var idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.disabled) {
          idInput.disabled = false;
        }
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  document.addEventListener("shopify:section:load", function () {
    enableVariantIdInputs();
    fixProductSubmitButtons();
  });
})();

/**
 * Mobile variant picker bottom sheet: force sizing via shadow DOM and hide chat.
 * CSS alone is unreliable because the popover is moved to document.body on open.
 */
(function () {
  var MOBILE_QUERY = "(max-width: 999px)";
  var CHAT_SELECTORS =
    '#shopify-chat, inbox-online-store-chat, #ShopifyChat, [id*="shopify-chat"], [id*="ShopifyChat"]';
  var POPOVER_SELECTOR =
    "x-popover.variant-picker-popover, x-popover[id*='popover-variant-dropdown']";

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function chatNodes() {
    return document.querySelectorAll(CHAT_SELECTORS);
  }

  function setChatVisible(visible) {
    chatNodes().forEach(function (node) {
      node.style.setProperty("visibility", visible ? "" : "hidden", "important");
      node.style.setProperty("pointer-events", visible ? "" : "none", "important");
    });
  }

  function shadowPart(popover, name) {
    return popover.shadowRoot
      ? popover.shadowRoot.querySelector('[part="' + name + '"]')
      : null;
  }

  function applyMobileSheetStyles(popover) {
    if (!isMobile()) {
      return;
    }

    popover.classList.add("variant-picker-popover--mobile-sheet");
    popover.style.setProperty("z-index", "2147483647", "important");

    var content = shadowPart(popover, "content");
    var header = shadowPart(popover, "header");
    var body = shadowPart(popover, "body");

    if (content) {
      content.style.setProperty("width", "100%", "important");
      content.style.setProperty("min-height", "auto", "important");
      content.style.setProperty("max-height", "75dvh", "important");
      content.style.setProperty("border-radius", "1rem 1rem 0 0", "important");
    }

    if (header) {
      header.style.setProperty("min-height", "auto", "important");
      header.style.setProperty("padding-top", "1rem", "important");
      header.style.setProperty("padding-bottom", "1rem", "important");
    }

    if (body) {
      body.style.setProperty("padding", "1.25rem", "important");
      body.style.setProperty(
        "padding-bottom",
        "calc(1.25rem + env(safe-area-inset-bottom, 0px))",
        "important"
      );
    }

    popover.querySelectorAll(".popover__value-list > button").forEach(function (button) {
      button.style.setProperty("min-height", "3.25rem", "important");
      button.style.setProperty("padding", "0.875rem 1rem", "important");
      button.style.setProperty("font-size", "1rem", "important");
      button.style.setProperty("border-radius", "0.75rem", "important");
    });

    setChatVisible(false);
  }

  function clearMobileSheetStyles(popover) {
    popover.classList.remove("variant-picker-popover--mobile-sheet");
    popover.style.removeProperty("z-index");

    ["content", "header", "body"].forEach(function (name) {
      var part = shadowPart(popover, name);
      if (part) {
        part.removeAttribute("style");
      }
    });

    popover.querySelectorAll(".popover__value-list > button").forEach(function (button) {
      button.removeAttribute("style");
    });

    setChatVisible(true);
  }

  function bindVariantPopoverFix(root) {
    var scope = root || document;
    scope.querySelectorAll(POPOVER_SELECTOR).forEach(function (popover) {
      if (popover.dataset.mobileSheetBound === "true") {
        return;
      }
      popover.dataset.mobileSheetBound = "true";

      popover.addEventListener("dialog:after-show", function () {
        applyMobileSheetStyles(popover);
      });

      popover.addEventListener("dialog:after-hide", function () {
        clearMobileSheetStyles(popover);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bindVariantPopoverFix();
    });
  } else {
    bindVariantPopoverFix();
  }

  document.addEventListener("shopify:section:load", function (event) {
    bindVariantPopoverFix(event.target);
  });
})();
